import React from "react";
import { ContentLayout, HeaderBreadcrumbs } from "../../../shared";
import { GeneralSettings } from "./GeneralSettings";
import { EmailSettingsList } from "../../EmailSettings";

export const SettingsDetails = () => {
  const breadcrumbs = [{ name: "Dashboard", href: "/" }, { name: "Settings" }];

  const tabs = React.useMemo(
    () => [
      {
        label: "General",
        value: "1",
        panel: <GeneralSettings />,
      },
      {
        label: "Emails",
        value: "2",
        panel: <EmailSettingsList />,
      },
    ],
    []
  );

  return (
    <ContentLayout
      title="Settings"
      breadcrumbs={<HeaderBreadcrumbs links={breadcrumbs} />}
      tabProps={{
        label: "superAdminSettings",
        list: tabs,
      }}
    >
    </ContentLayout>
  );
};
